// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"283d997b","568":"b94d102f","915":"337b0551","971":"249f71ed"}[chunkId] + ".chunk.js";
};